import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { FaShoppingBag, FaTag, FaCalendarCheck, FaTruck, FaMoneyBillWave, FaTrash } from 'react-icons/fa';
import RecycleSlider from './RecycleSlider';

const steps = [
   {
      icon: <FaTrash className="text-3xl text-[#1a4632]" />,
      title: "Seal & Secure",
   },
   {
      icon: <FaShoppingBag className="text-3xl text-[#1a4632]" />,
      title: "Bag & Tag",
   },
   {
      icon: <FaTag className="text-3xl text-[#1a4632]" />,
      title: "Label It Up",
   },
   {
      icon: <FaCalendarCheck className="text-3xl text-[#1a4632]" />,
      title: "Book a Pickup",
   },
   {
      icon: <FaTruck className="text-3xl text-[#1a4632]" />,
      title: "Pickup Confirmed & Bag Collected",
   },
   {
      icon: <FaMoneyBillWave className="text-3xl text-[#1a4632]" />,
      title: "Rewards Credited",
   },
];

const RecycleProcess = () => {
   return (
      <div className="">
         <Header />
         <section className="py-16 bg-white text-center px-4">
            <div className="max-w-7xl mx-auto relative">
               {/* Section Title */}
               <div className="mb-2 text-sm tracking-wide text-[#9cc026]">
                  <div className="flex justify-center items-center gap-4">
                     <span className="uppercase font-medium">How We Work</span>
                  </div>
               </div>
               <h2 className="text-3xl font-bold text-[#1a4632] text-center mb-6">
                  Recycle<span className="text-[#9cc026]"> Process</span>
               </h2>

               {/* Step Items */}
               <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 relative">
                  {steps.map((step, index) => (
                     <div key={index} className="flex flex-col items-center text-center relative z-10">
                        <div className="border-2 border-[#9cc026] rounded-full w-20 h-20 flex items-center justify-center mb-4 bg-white">
                           {step.icon}
                        </div>
                        <h3 className="text-lg font-semibold text-[#9cc026] mb-2">
                           {step.title}
                        </h3>
                        <p className="text-sm text-gray-600 px-2">{step.description}</p>
                     </div>
                  ))}
               </div>

               {/* Connecting Line */}
               <div className="hidden lg:block absolute top-[125px] left-0 right-0 mx-auto w-[90%] h-px bg-[#9cc026] z-0" />
            </div>
         </section>
         <RecycleSlider />
         <Footer />
      </div>
   );
};

export default RecycleProcess;
